import React, { useContext } from 'react';
import styles from './VideoTextRow.module.css';
import { Link } from 'react-router-dom';

// import { CopyDeckConfig } from '../../Context/CopyDeckConfig';

const VideoTextRow = (props) => {
	// const { copyDeck } = useContext(CopyDeckConfig);
	const containerClass = styles.video_row + " " + styles.reverse;
	const title = props.title;
	const text = props.text;
	const links = props.links;
	const image_src = props.image_src;
	const image_alt = props.image_alt;
	console.log(links);
	return (
		<div className={containerClass}>

			<div className={styles.video_overlay} style={{ /*bottom:'10%'*/ }}>
				<span>{title}</span>
				<br />
				{text}
				<div className={styles.button_row}>
					{links.map((elem,index) => ((
						<Link
								data-tealium-category="link"
								data-tealium-action="click"
								data-tealium-type="action"
								data-tealium-value= {`${elem[1]}|${elem[0]}`}
							key={index}
							to={elem[0]}
						>
							{elem[1]}
						</Link>
					)))}
				</div>
			</div>

			<img src={image_src} alt={image_alt} className={styles.video_image} />

			{
				/*
				<div className={styles.container}>
					<div className={styles.left}>
						<img src={'/vt/images/InfieldLogo.jpg'} alt={"Innovation Tours"}/>
					</div>
					<div className={styles.right}>
						<span dangerouslySetInnerHTML={{ __html: copyDeck.headline.copy }} />
					</div>
				</div>
				*/
			}

		</div>
	);
}


export default VideoTextRow;